import React, { useEffect, useRef, useState } from 'react';
import benefits from './benefits.json';
import assets from './assets';
import './style.scss';

const pageTitle = 'GHA探索之旅-会员礼遇';

export default function GHABenefits() {
  const [activeIndex, setActiveIndex] = useState(0);
  const pageRef = useRef(null);
  const tabRefs = useRef([]);
  const activeTier = benefits.tiers[activeIndex];

  useEffect(() => {
    document.title = pageTitle;
    // Other routes apply global container widths and image styles.
    const host = pageRef.current.closest('.container');
    if (!host) return undefined;
    host.classList.add('gha-benefits-host');
    return () => host.classList.remove('gha-benefits-host');
  }, []);

  const handleTabKeyDown = (event, index) => {
    let nextIndex;
    switch (event.key) {
      case 'ArrowRight': nextIndex = (index + 1) % benefits.tiers.length; break;
      case 'ArrowLeft': nextIndex = (index + benefits.tiers.length - 1) % benefits.tiers.length; break;
      case 'Home': nextIndex = 0; break;
      case 'End': nextIndex = benefits.tiers.length - 1; break;
      default: return;
    }
    event.preventDefault();
    setActiveIndex(nextIndex);
    tabRefs.current[nextIndex].focus();
  };

  return (
    <main ref={pageRef}>

      <h1 className="hotel-member-title">
        <img className="hotel-member-logo preferred-logo" src="https://staticfile.badazhou.com/20260922/3746a3b0306309f8ea6e693425cc825e.png" alt="" />
        <span>{pageTitle}</span>
      </h1>

      <div className="gha-benefits">
        <div className="mobile-card-rights">
        <div className="g-main-content">
          <div className="user-page-wrap">
            <div className="user-dashboard-wrap">
              <div className={`level-step-container active-${activeIndex + 1}`}>
                <div className="line-track" aria-hidden="true">
                  <span style={{ width: `${activeTier.progress}%` }} />
                </div>
                <div className="level-list" role="tablist" aria-label="会员等级">
                  {benefits.tiers.map((tier, index) => (
                    <button
                      key={tier.id}
                      ref={(node) => { tabRefs.current[index] = node; }}
                      type="button"
                      role="tab"
                      id={`gha-tab-${tier.id}`}
                      className={`level-item level-item--${tier.id}`}
                      aria-selected={activeIndex === index}
                      aria-controls={`gha-panel-${tier.id}`}
                      tabIndex={activeIndex === index ? 0 : -1}
                      onClick={() => setActiveIndex(index)}
                      onKeyDown={(event) => handleTabKeyDown(event, index)}
                    >
                      <span className="level-label">{tier.label}</span>
                      <span className="tracker" aria-hidden="true"><span /></span>
                    </button>
                  ))}
                </div>
                <div className="level-card-m">
                  {benefits.tiers.map((tier, index) => (
                    <img
                      key={tier.id}
                      src={assets[tier.card]}
                      alt={`GHA探索之旅${tier.label}会员卡`}
                      width="338"
                      height="218"
                      hidden={activeIndex !== index}
                    />
                  ))}
                </div>
              </div>
              {benefits.tiers.map((tier, index) => (
                <section
                  key={tier.id}
                  className="card-panel"
                  id={`gha-panel-${tier.id}`}
                  role="tabpanel"
                  aria-labelledby={`gha-tab-${tier.id}`}
                  tabIndex={0}
                  hidden={activeIndex !== index}
                >
                  <div className="gha-divider"><h2>{tier.heading}</h2></div>
                  <ul className="benefit-list">
                    {tier.items.map((item) => (
                      <li className="benefit-item" key={item.id}>
                        <div className="benefit-icon">
                          <img src={assets[item.icon]} alt="" />
                        </div>
                        <p>{item.text}</p>
                      </li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>
    </main>
  );
}
